import React, { Component } from "react";
import {
  Button,
  Form,
  Modal,
  Row,
  Input,
  Checkbox,
  Select,
  Col,
  Spin,
  Tooltip
} from "antd";
import CloseIcon from "../../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setkeyboardEnabled } from "../../../actions/AppAction";
import {
  sendShareAssets,
  sendShareAsset
} from "../../../actions/AssetsShareAction";
import { sendNotification } from "../../../utils/index";
import { shareFolder } from "../../../actions/ClientAction";
import { getRoot } from "../../../actions/AssetsRootAction";
import { getExplore } from "../../../actions/AssetsExploreAction";
import fileextension from "file-extension";
import SVGView from "../../assets-view/SVGView";
import { VideoView } from "../../assets-view/VideoView";
import DocumentView from "../../document-view/DocumentView";
import { deleteSelectedAsset } from "../../../actions/ClientAction";
import { getBreadCrumbs } from "../../../utils";
import Helper from "../../helper/Helper";
import { isEmail } from "../../../utils/index";
import BunkeyAPI from "../../../api/BunkeyAPI";
import { getNewPermission } from '../../../utils/index';
import { fetchUsersToMentionAll } from '../../../api/GroupApi';
import "./ShareModal.css";
import { cancelSelect } from "../../../actions/MultiselectAction";
import { isRightsDownloadBlocked } from "../../../utils/rights";

const { Option } = Select;

const spinnerStyle = {
  textAlign: "center",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0"
};

class ShareModal extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.myInputCopyLink = React.createRef();

    this.state = {
      emails: [],
      plainOptions: ["10", "30", "60", "90", "120"],
      selectedOption: "10",
      folderId: props.selectedFile._id,
      message: "",
      showPasswordInputs: false,
      addPassword: "",
      confirmPassword: "",
      users: [],
      copyLink: "",
      showCopyLink: false,
      loadingButtonLink: false,
      showSpinnerEmail: true
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const isFolder = this.isFolderOrBunker();
    if (isFolder) {
      this.handleFolderSelect(this.props.selectedFile._id);
    }
    this.fetchUsers();
    this.props.setkeyboardEnabled(true);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    const {
      sharingAsset: sharingAssetOld,
      sharingFolder: sharingFolderOld
    } = prevProps;
    const {
      sharingAsset: sharingAssetNew,
      sharingFolder: sharingFolderNew,
      sharingAssetSuccess: sharingAssetSuccessNew,
      sharingFolderSuccess: sharingFolderSuccessNew
    } = this.props;

    if (!sharingAssetNew && sharingAssetOld && sharingAssetSuccessNew) {
      this.handleOnHideModal();
    }
    if (!sharingFolderNew && sharingFolderOld && sharingFolderSuccessNew) {
      this.handleOnHideModal();
    }
  }

  isFolderOrBunker = () => {
    const isFolder =
      this.props.selectedFile.type === "bunker" ||
      this.props.selectedFile.type === "folder";
    return isFolder;
  };

  isDownloadBlocked = () =>
    isRightsDownloadBlocked(this.props.selectedFile, this.props.modules);

  notifyBlockedDownload = () => {
    sendNotification(
      "warning",
      this.props.intl,
      this.props.intl.formatMessage({ id: "rights_download_blocked" })
    );
  };

  handleSendShared = () => {
    const { selectedFile, workclient, user, intl, newMatrix } = this.props;
    const {
      message,
      emails,
      showPasswordInputs,
      addPassword,
      confirmPassword,
      folderId,
      selectedOption
    } = this.state;

    if (this.isDownloadBlocked()) {
      this.notifyBlockedDownload();
      return;
    }

    const canShare =
      user.clientRole !== "admin" && user.role !== "admin"
        ? getNewPermission(folderId, newMatrix, "shareFolder")
        : true;

    if (!canShare) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "permission_denied" })
      );
      return;
    }

    if (emails.length === 0) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "empty_email_share" })
      );
      return;
    }

    if (
      showPasswordInputs &&
      confirmPassword.length === 0 &&
      addPassword.length === 0
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "must_enter_password" })
      );
      return;
    }

    if (
      addPassword.length > 0 &&
      confirmPassword.length > 0 &&
      addPassword !== confirmPassword
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "not_equal_passwords" })
      );
      return;
    }

    const isFolder =
      this.props.selectedFile.type === "bunker" ||
      this.props.selectedFile.type === "folder";

    if (isFolder) {
      this.props.shareFolder(
        workclient,
        folderId,
        emails,
        user,
        confirmPassword,
        message,
        intl,
        parseInt(selectedOption)
      );
    } else {
      this.props.sendShareAsset(
        workclient,
        user,
        selectedFile,
        message,
        confirmPassword,
        emails,
        intl,
        parseInt(selectedOption)
      );
    }
  };

  fetchUsers = () => {
    this.setState({ showSpinnerEmail: true })        
    const { workclient } = this.props;
    // const { selectedFile, workclient } = this.props;

    // const {folderId} = this.state;

    
    // const isFolder = this.isFolderOrBunker();
    
    // fetchUsersToMentionFalse(workclient, isFolder ? folderId : selectedFile._id)
    fetchUsersToMentionAll(workclient, 1)
      .then(res => {
        // const { adminUsers, operatorUsers } = res.data
        // console.log(res.data);
        // const usersMentions = [...adminUsers, ...operatorUsers]
        const usersMentions = res.data;
        const usersMentionsSorted = usersMentions.sort((firstUser, secondUser) => {
          if (firstUser.name.toLowerCase() < secondUser.name.toLowerCase())
            return -1
          if (firstUser.name.toLowerCase() === secondUser.name.toLowerCase())
            return 0
          return 1
        })

        if (this._isMounted) {
          this.setState({
            users: usersMentionsSorted,
            showSpinnerEmail: false
          });
        }
      })
      .catch(err => {
        if (this._isMounted) {
          this.setState({
            errorFetchingUsers: err,
            showSpinnerEmail: false
          });
        }
      });
  };

  handleSendLinkShare = changeSelectedOption => {
    const { intl, selectedFile, user, workclient, newMatrix } = this.props;
    const {
      addPassword,
      confirmPassword,
      folderId,
      selectedOption,
      plainOptions
    } = this.state;

    if (this.isDownloadBlocked()) {
      this.notifyBlockedDownload();
      return;
    }

    if (
      (addPassword.length > 0 || confirmPassword.length > 0) &&
      addPassword !== confirmPassword
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "multi-share-unmatch-passwords" })
      );
      return;
    }

    const canShare =
      user.clientRole !== "admin" && user.role !== "admin"
        ? getNewPermission(folderId, newMatrix, "shareFolder")
        : true;

    if (!canShare) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "permission_denied" })
      );
      return;
    }

    const isBunker =
      selectedFile.type === "folder" || selectedFile.type === "bunker";
    console.log(
      "changeSelectedOption => ",
      plainOptions.includes(changeSelectedOption)
    );
    this.setState(
      {
        loadingButtonLink: true
      },
      () =>
        BunkeyAPI({
          url: `/shared/getDownloadLink`,
          method: "POST",
          data: {
            object: isBunker ? folderId : selectedFile._id,
            user: user,
            password: confirmPassword,
            client: workclient,
            expiresIn:
              changeSelectedOption &&
              plainOptions.includes(changeSelectedOption)
                ? parseInt(changeSelectedOption)
                : parseInt(selectedOption)
          }
        })
          .then(resp => {
            if (resp.data && resp.data.unavailable) {
              this.setState({ loadingButtonLink: false });
              this.notifyBlockedDownload();
              return;
            }
            this.setState({
              copyLink: resp.data,
              showCopyLink: true,
              loadingButtonLink: false
            });

            this.myInputCopyLink.focus();
            this.myInputCopyLink.input.setSelectionRange(0, 9999);
          })
          .catch(err => {
            console.log(err);
            this.setState({ loadingButtonLink: false });
            sendNotification(
              "error",
              intl,
              intl.formatMessage({ id: "error_copy_link" })
            );
          })
    );
  };

  handleProcessBreadCrumbs = folderselect => {
    const breadcrumb = getBreadCrumbs(folderselect);
    if (breadcrumb && breadcrumb.length > 0) {
      return breadcrumb
        .filter(r => r.id !== folderselect)
        .map(r => r.name)
        .join("/");
    } else {
      return "";
    }
  };

  handleFolderSelect = folderId => {
    this.setState({
      folderId: folderId,
      breadcrumbState: this.handleProcessBreadCrumbs(folderId)
    });
  };

  handleOnHideModal = () => {
    this.props.handleHiddenModal();
  };

  handleOnInputChange = e => {
    this.setState({
      message: e.target.value
    });
  };

  handleShowPasswordInputs = () => {
    const { showPasswordInputs } = this.state;
    this.setState({
      showPasswordInputs: !showPasswordInputs
    });
  };

  handleAddPass = e => {
    this.setState({
      addPassword: e.target.value
    });
  };

  handleConfirmPass = e => {
    this.setState({
      confirmPassword: e.target.value
    });
  };

  handleChangeEmail = values => {
    const onlyValidEmails = values.filter(email => isEmail(email));
    this.setState({ emails: onlyValidEmails });
  };

  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      selectedFile,
      sharingAsset,
      sharingFolder
    } = this.props;

    const {
      plainOptions,
      selectedOption,
      message,
      showPasswordInputs,
      addPassword,
      confirmPassword,
      emails,
      users,
      showCopyLink,
      copyLink,
      loadingButtonLink,
      showSpinnerEmail
    } = this.state;

    const isBunker =
      selectedFile.type === "folder" || selectedFile.type === "bunker";
    const prefix = isBunker ? "" : "_file";

    const optionsUser = users.map(user => {
      return (
        <Option key={user._id} value={user.email} uid={user._id}>
          {`${user.name} (${user.email})`}
        </Option>
      );
    });
    const optionsSpinner = (
      <Option key={"spinner_loading"}>
        <div style={spinnerStyle}>
          <Spin spinning={true} />
        </div>
      </Option>
    );

    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="share-modal"
      >
        <Form>
          <div className="share-modal-title">
            {intl.formatMessage({ id: `share-modal-title${prefix}` })}
          </div>

          {/* Asset view */}
          {!isBunker && (
            <div className="share-modal-fileview-wrapper">
              <p className="share-modal-label">{`${intl.formatMessage({ id: "share_drawer_title" })} ${selectedFile.name}`}</p>
              <div className="share-modal-view-wrapper">
                {selectedFile.type === "image" &&
                  fileextension(selectedFile.originalURL) === "svg" && (
                    <SVGView
                      comFromMiddleView={true}
                      src={selectedFile.originalURL}
                      assetId={selectedFile._id}
                    />
                  )}
                {selectedFile.type === "image" &&
                  fileextension(selectedFile.originalURL) !== "svg" && (
                    <img
                      alt={selectedFile.name}
                      src={selectedFile.mediaQualityURL}
                      className="share-modal-img"
                    />
                  )}
                {selectedFile.type === "video" && (
                  <VideoView
                    url={selectedFile.lowQualityURL}
                    disableDefaultControls={false}
                    autoPlay={false}
                    muted={false}
                    divWidth={300}
                    from="list"
                  />
                )}
                {selectedFile.type === "document" && (
                  <DocumentView item={selectedFile} from={`middleView`} />
                )}
              </div>
            </div>
          )}
          {/* Folder view
          {isBunker && isBunker === true && (
            <div className="share-modal-fileview-wrapper">
              <Breadcrumb
                title={intl.formatMessage({ id: `crudfolder_share_folder` })}
                value={selectedFile._id}
                placeholder={intl.formatMessage({ id: "delete_folder_select" })}
                handleFolderSelect={this.handleFolderSelect}
                changeFolder={false}
                permissionAware={
                  user.clientRole === "admin" || user.role === "admin"
                    ? false
                    : true
                }
                permissionsArray={["shareFolder"]}
              />
            </div>
          )} */}
          {/* Folder view */}
          {isBunker && isBunker === true && (
            <div className="share-modal-fileview-wrapper">
              <Input
                type="text"
                disabled
                value={selectedFile ? selectedFile.name : ""}
              />
            </div>
          )}
          <Form.Item
            label={intl.formatMessage({ id: "multi-share-share-days" })}
          >
            <Row style={{ width: "100%" }}>
              {plainOptions.map(item => {
                return (
                  <Col span={4} key={item}>
                    <Checkbox
                      value={item}
                      onChange={value => {
                        if (selectedOption !== item && showCopyLink) {
                          this.handleSendLinkShare(value.target.value);
                        }
                        this.setState({
                          selectedOption: value.target.value
                        });
                      }}
                      checked={selectedOption === item}
                    >
                      {item}
                    </Checkbox>
                  </Col>
                );
              })}
            </Row>
          </Form.Item>
          <Form.Item>
            <Tooltip
              title={
                this.isDownloadBlocked()
                  ? intl.formatMessage({ id: "rights_asset_out" })
                  : null
              }
            >
              <span>
                <Button
                  size={"large"}
                  htmlType={"button"}
                  type={"primary"}
                  className="share-modal-button"
                  loading={loadingButtonLink}
                  disabled={this.isDownloadBlocked()}
                  onClick={this.handleSendLinkShare}
                >
                  {intl.formatMessage({ id: "generate_link" })}
                </Button>
              </span>
            </Tooltip>
          </Form.Item>
          {showCopyLink && (
            <Form.Item style={{ marginBottom: 18 }}>
              <Input.Group compact size={"large"}>
                <Input
                  style={{ width: "70%" }}
                  ref={ref => (this.myInputCopyLink = ref)}
                  type="text"
                  value={copyLink}
                  readOnly
                />
                <Button
                  size={"large"}
                  type={"primary"}
                  style={{ width: "30%" }}
                  onClick={() => {
                    navigator.clipboard.writeText(copyLink);
                    sendNotification(
                      "success",
                      intl,
                      intl.formatMessage({ id: "link_copied" })
                    );
                    this.props.cancelSelect();
                    handleHiddenModal();
                  }}
                >
                  {intl.formatMessage({ id: "multi-share-share-copy" })}
                </Button>
              </Input.Group>
            </Form.Item>
          )}
          <p className="share-modal-label">
            {intl.formatMessage({ id: "add_email" })}
          </p>
          <Form.Item>
            <Select
              mode="tags"
              style={{ width: "100%" }}
              onChange={this.handleChangeEmail}
              tokenSeparators={[","]}
              value={emails}
            >
              {showSpinnerEmail && optionsSpinner}
              {optionsUser}
            </Select>
          </Form.Item>
          <Form.Item>
            <Checkbox onChange={this.handleShowPasswordInputs}>
              {intl.formatMessage({ id: "add_password" })}
              <Helper
                title={"helper_title"}
                content={"helper_add_password"}
                trigger={`click`}
              />
            </Checkbox>
            {showPasswordInputs && (
              <Input.Group className="input-group">
                <Input.Password
                  className="pass-input"
                  placeholder={intl.formatMessage({ id: "add_password" })}
                  value={addPassword}
                  autoComplete="new-password"
                  onChange={this.handleAddPass}
                />
                <Input.Password
                  className="pass-input"
                  placeholder={intl.formatMessage({ id: "confirm_password" })}
                  value={confirmPassword}
                  autoComplete="new-password"
                  onChange={this.handleConfirmPass}
                />
              </Input.Group>
            )}
          </Form.Item>
          <p className="share-modal-label">
            {intl.formatMessage({ id: "message" })}
          </p>
          <Form.Item>
            <Input.TextArea
              placeholder={intl.formatMessage({ id: "message" })}
              rows={5}
              value={message}
              onChange={this.handleOnInputChange}
            />
          </Form.Item>
        </Form>
        <Row type={"flex"} justify={"space-between"}>
          <Button
            size={"large"}
            type={"primary"}
            loading={sharingAsset || sharingFolder}
            className="share-modal-button accept"
            onClick={this.handleSendShared}
          >
            {intl.formatMessage({ id: "shared_share" })}
          </Button>
          <Button
            size={"large"}
            type={"primary"}
            ghost
            onClick={handleHiddenModal}
            className="share-modal-button cancel"
          >
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedFile: state.individualSelect.selectedFile,
    workclient: state.client.data ? state.client.data._id : null,
    user: state.authUser.user,
    breadcrumb: state.client.breadcrumb,
    keyCollection: state.individualSelect.keyCollection,
    sharingAsset: state.assetsShared.sharing,
    sharingAssetSuccess: state.assetsShared.sended,
    sharingFolder: state.client.isInFolderAction,
    sharingFolderSuccess: state.client.isShared,
    newMatrix: state.group.newMatrix,
    modules: state.client.data ? state.client.data.modules : []
  };
};

const mapDispatchToProps = {
  setkeyboardEnabled,
  sendShareAsset,
  sendShareAssets,
  getRoot,
  getExplore,
  deleteSelectedAsset,
  shareFolder,
  cancelSelect
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ShareModal))
);
